import { useState } from 'react';
import ComicCard from '@/components/feature/ComicCard';
import { comics, categories } from '@/mocks/comics';

export default function LatestUpdates() {
  const tabs = [{ slug: 'all', name: '全部更新' }, ...categories.map((c) => ({ slug: c.slug, name: c.name }))];
  const [active, setActive] = useState('all');

  const list = active === 'all' ? comics : comics.filter((c) => c.category === active);

  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6">
      <div className="mb-6 flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
        <div>
          <h2 className="font-heading text-2xl text-foreground-950">最新更新</h2>
          <p className="mt-2 text-sm text-foreground-600">实时追更今日深夜档新章，剧情不等待</p>
        </div>
        <div className="flex flex-wrap items-center gap-1 rounded-full border border-background-200 bg-background-100 p-1">
          {tabs.map((t) => (
            <button
              key={t.slug}
              type="button"
              onClick={() => setActive(t.slug)}
              className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
                active === t.slug
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-600 hover:bg-secondary-100 hover:text-foreground-950'
              }`}
            >
              {t.name}
            </button>
          ))}
        </div>
      </div>

      <div data-product-shop className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
        {list.map((c) => (
          <ComicCard key={c.id} comic={c} />
        ))}
      </div>
    </section>
  );
}